import PropTypes from 'prop-types';
import React from 'react';

/**
 * Shared lead + trail label for regional settings option rows
 * (currency symbol/code, country code/name, etc.).
 */
const RegionalSettingsOptionLabel = ({ lead, trail }) => (
  <span className="RegionalSettingsOptionLabel">
    <span className="RegionalSettingsOptionLabel__lead">{lead}</span>
    {trail != null && trail !== '' && (
      <span className="RegionalSettingsOptionLabel__trail">{trail}</span>
    )}
  </span>
);

RegionalSettingsOptionLabel.propTypes = {
  lead: PropTypes.node.isRequired,
  trail: PropTypes.node,
};

RegionalSettingsOptionLabel.defaultProps = {
  trail: undefined,
};

export default RegionalSettingsOptionLabel;
